import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { addCartItem, removeCartItem, setCartItemQuantity } from './cartOperations';

const CartContext = createContext(null);

const load = () => {
  try {
    return JSON.parse(localStorage.getItem('aura-cart')) || [];
  } catch {
    return [];
  }
};

export { variantForSize } from './cartOperations';

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('aura-cart', JSON.stringify(items));
  }, [items]);

  const add = useCallback((product, selection, qty = 1) => {
    setItems((previous) => addCartItem(previous, product, selection, qty));
  }, []);

  const remove = useCallback((key) => setItems((previous) => removeCartItem(previous, key)), []);

  const setQty = useCallback((key, qty) => setItems((previous) => setCartItemQuantity(previous, key, qty)), []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, x) => s + x.qty, 0);
  const subtotal = items.reduce((s, x) => s + x.qty * x.price, 0);
  const isShopify = items.length > 0 && items.every((x) => x.variantId);

  const value = useMemo(
    () => ({ items, count, subtotal, isShopify, add, remove, setQty, clear, open, setOpen }),
    [add, clear, count, isShopify, items, open, remove, setQty, subtotal]
  );

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
